export default __webpack_public_path__ + "72b7330723fa2b30e506480b6b39a239.jpg";